/**
 * @file components/biz/common/dialogPlainAction.js
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import _ from 'lodash';

import {createPayload} from '../../common/helper';
import {DialogOption} from '../index';

export function dialogPlainAction(dialogOption: DialogOption, payload: any) {

    const {className, width, title, maskClosable, body, foot, cancelWithSuccess, okText} = dialogOption;
    const $title = _.template(title)(payload);

    const {$payloadFields, $extraPayload, content} = body;
    payload = createPayload(payload, $payloadFields, $extraPayload);

    const dialogInfo: any = {
        dialogType: 'plain',
        className,
        title: $title,
        width,
        maskClosable,
        cancelWithSuccess,
        foot,
        okText,
        payload
    };

    if (typeof content === 'function') {
        dialogInfo.wrappedComponent = content;
    }
    else {
        dialogInfo.message = _.template(content)(payload);
    }
    return dialogInfo;
}
